import { useAppSelector } from '../../hooks';
import { ValidationResultType } from '../../hooks/useFieldValidation';
import useTranslation from '../../hooks/useTranslation';
import { selectFieldValue } from '../../store/applicationform/applicationFormSelectors';
import MonetaryField from '../MonetaryField/MonetaryField';
import Subtitle from '../Subtitle/Subtitle';

const AdditionalConsolidationAmountField = () => {
    const translate = useTranslation();
    const loanAmount = useAppSelector(selectFieldValue)('amount');

    const consolidationAmountValidation = async (value?: string): Promise<ValidationResultType> => {
        const numericValue = Number(value ?? 0);
        const isValid = numericValue >= 0 && numericValue <= Number(loanAmount);

        return {
            valid: isValid,
            errorMessageKey: isValid ? undefined : translate('field.additional-consolidation-amount.error'),
        };
    };
    return (
        <>
            <Subtitle text={translate('page.purpose-of-loan.subtitle.consolidation-amount')} />
            <MonetaryField
                name="additionalConsolidationAmount"
                label={translate('field.additional-consolidation-amount.label')}
                customValidation={consolidationAmountValidation}
            />
        </>
    );
};

export default AdditionalConsolidationAmountField;
